import {
  RecurrenceInterval,
  RECURRENCE_INTERVAL_DISPLAY,
  DAY_OF_WEEK_DISPLAY,
  WEEK_INDEX_DISPLAY,
} from "@mimber/schema"

export const INTERVAL_OPTIONS = (
  Object.entries(RECURRENCE_INTERVAL_DISPLAY) as [
    RecurrenceInterval,
    { label: string },
  ][]
).map(([value, { label }]) => ({ label, value }))

export const DAY_OF_WEEK_OPTIONS = (
  Object.entries(DAY_OF_WEEK_DISPLAY) as [
    string,
    { label: string; short: string },
  ][]
).map(([value, { label }]) => ({ label, value }))

export const WEEK_INDEX_OPTIONS = (
  Object.entries(WEEK_INDEX_DISPLAY) as [string, { label: string }][]
).map(([value, { label }]) => ({ label, value }))

export const MONTH_OPTIONS = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
]
